define('views/header/Podio.Views.HeaderSearch',['require','translate','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.AutoCompleter','lib/Podio.Transport.Picker','lib/Podio.Browser','lib/Podio.Utils','lib/Podio.UI','lib/Podio.Router.Content','lib/backbone/Backbone.Mixins.Transport.API','lib/Podio.Statsd','controllers/Podio.Controllers.DynamicContentManager','lib/Podio.Tracking.Pendo.Search','lib/Podio.Routes','jst!autocompleter/_loading_no_text'],function(require) {

  var t = require('translate');
  var _ = require('underscore');
  var $ = require('jquery');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var AutoCompleter = require('lib/Podio.UI.AutoCompleter');
  var transportPicker = require('lib/Podio.Transport.Picker');
  var podioBrowser = require('lib/Podio.Browser');
  var podioUtils = require('lib/Podio.Utils');
  var podioUI = require('lib/Podio.UI');
  var podioContentRouter = require('lib/Podio.Router.Content');
  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');
  var podioStatsd = require('lib/Podio.Statsd');
  var DynamicContentManager = require('controllers/Podio.Controllers.DynamicContentManager');
  var pendoHelper = require('lib/Podio.Tracking.Pendo.Search');

  var routes = require('lib/Podio.Routes');

  var jstLoadingNoText = require('jst!autocompleter/_loading_no_text');

  return ViewPodioBase.extend({
    initialize : function(options) {
      _.bindAll(this, 'render', 'onSearchOutsideClick', 'onInputBoxInput', 'onAutoCompleterItemSelected', 'onAutoCompleterItemSecondaryActionClicked', 'onItemSecondaryActionHighlight', 'onInputBoxKeydown', 'formatResult');

      this.elm = $(this.el);

      this.elmInput = this.elm.find('input');

      if (this.elmInput.data('ref-type')) {
        this.baseContext = {
          type: this.elmInput.data('ref-type'),
          id: this.elmInput.data('ref-id'),
          name: this.elmInput.data('ref-name')
        };
      }


      this.elmInput.bind('input', _.debounce(this.onInputBoxInput, 300));
      this.elmInput.bind('keydown', this.onInputBoxKeydown);

      this.autoCompleter = new AutoCompleter(this.elm, {
        useAbsolutePosition: true,
        enableTabKey: false,
        selectFirstItem: false,
        positionType: 'fixed',
        escapeInfo: false,
        widthOffset: 0,
        topOffset: 1,
        classes: {
          autoCompleteItemActive : 'active',
          item : 'item',
          autocompleter : 'header-search-autocomplete header-search-large'
        }
      });

      this.autoCompleter.templates.loading = jstLoadingNoText;

      this.autoCompleter.signals.onItemSelected.add(this.onAutoCompleterItemSelected);
      this.autoCompleter.signals.onItemSecondaryActionClicked.add(this.onAutoCompleterItemSecondaryActionClicked);
      this.autoCompleter.signals.onItemSecondaryActionHighlight.add(this.onItemSecondaryActionHighlight);
    },

    onItemSecondaryActionHighlight: function(toggle, elmTarget) {
      elmTarget.find('.secondary-action .icon-16').toggleClass('icon-16-tealplus', toggle);
      elmTarget.find('.secondary-action .icon-16').toggleClass('icon-16-green-plus-slim', !toggle);
    },

    onAutoCompleterItemSecondaryActionClicked: function(url, e) {
      var contentManager = DynamicContentManager.getInstance();
      var navigateToContent = function() {
        podioContentRouter.navigate(url, { renderType: 'overlay' });
        this.autoCompleter.hide();
      }.bind(this);

      if (e && (e.metaKey || e.ctrlKey)) {
        window.open(url, '_blank');
      } else {
        if (contentManager.hasContent()) {
          if (contentManager.isOnPermalink()) {
            window.location = url;
          } else {
            contentManager.closeOverlay();
            navigateToContent();
          }
        } else {
          navigateToContent();
        }

        this.collapse();
      }
    },

    onAutoCompleterItemSelected: function(item, elmTarget, e) {
      podioStatsd.increment('search.top.result.' + item.type, null, true);
      if (item.link) {
        this.goToRef(item, e);
        // Pendo track event with time stamp
        pendoHelper.trackEndSearchEvent('top-search');
      } else if (item.custom && item.id === 'showAllResults') {
        this.submitForm();
      } else if (item.custom && item.id === 'showGlobalResults') {
        this.forceGlobal = true;
        this.searchRequest();
      }
    },

    getQuery: function() {
      return this.elmInput.val();
    },

    submitForm: function() {
      if (this.forceGlobal) {
        window.location = '/search#query/' + encodeURIComponent(this.getQuery());
      } else {
        this.elm.find('form').submit();
      }
    },

    goToRef: function(item, e) {
      if (e && (e.metaKey || e.ctrlKey)) {
        window.open(item.link, '_blank');
      } else {
        this.collapse();

        if (item.type === 'item') {
          podioContentRouter.navigate(item.link, { renderType: 'overlay' });
        } else {
          window.location = item.link;
        }
      }
    },

    onInputBoxKeydown: function(e) {
      if (e.keyCode === podioUI.KeyCodes.Return) {
        if (!this.autoCompleter.getActiveItemData()) {
          e.stopPropagation();
          e.preventDefault();
          this.submitForm();
        }
      }

      if (e.keyCode === podioUI.KeyCodes.Esc) {
        this.elmInput.blur();
        this.collapse();
        e.stopPropagation();
      }
    },

    onInputBoxInput: function(e) {
      if (!this.elm.hasClass('expanded')) {
        return;
      }

      this.searchRequest();
    },

    getFullResults: function(query) {
      return {
        custom: true,
        id: 'showAllResults',
        name: t('Show all results for #predictive_search') + ': ' + query,
        itemIcon: null,
        className : 'special-results',
        contextIcon: 'sprite-icon icon-arrow-bold-right-grey'
      };
    },

    getGlobalResults: function(title) {
      return {
        custom: true,
        id: 'showGlobalResults',
        name: t('Result in {0} #predictive_search').format(title),
        itemIcon: null,
        className : 'special-results global-results',
        suffix: t('Search globally #predictive_search')

      };
    },

    getNoResults: function(query) {
      return {
        custom: true,
        id: 'noResults',
        name: t('No results found for: {0} #quick_search').format(query),
        itemIcon: null,
        className : 'special-results'
      };
    },

    setResults: function(results, query) {
      var context = this.searchContext();

      var resultCount = results.length;

      results = _.clone(results);
      if (context) {
        results.unshift(this.getGlobalResults(context.name));
      }
      if (resultCount === 0) {
        results.push(this.getNoResults(query));
      }
      else if (query && resultCount >= 8) {
        results.push(this.getFullResults(query));
      }

      this.autoCompleter.populate(results, query);
    },

    searchRequest: function() {
      //Kill any existing searches so their results doesn't mess with new ones
      if (this.lastSearchRequest) {
        this.lastSearchRequest.abort();
        delete this.lastSearchRequest;
      }

      var query = this.getQuery();
      if (!query) {
        this.autoCompleter.hide();
        return;
      }

      this.autoCompleter.renderLoading();

      var self = this;

      var data = {
        limit: 8,
        target: 'search_quick',
        text: query
      };

      var context = this.searchContext();
      if (context && context.type) {
        data.target_params = {
          context: {
            type: context.type,
            id: context.id
          }
        };
      }

      this.lastSearchRequest = APITransport.request('post', '/reference/search', data);
      this.lastSearchRequest.done(function(responseData) {
        var results = [];
        if (responseData.length) {
          results = _.map(responseData[0].contents, self.formatResult);
        }

        self.setResults(results, query);
      });

      // Pendo track event with time stamp
      pendoHelper.trackStartSearchEvent('top-search');
    },

    searchContext: function() {
      if (!this.forceGlobal) {
        return this.baseContext;
      }
    },

    resultIcons: {
      task: 'icon-24 icon-24-task',
      space: 'icon-24 icon-space',
      app: function(result) {
        return 'app-icon-24 icon-{0}'.format(result.app.config.icon_id);
      },
      item: function(result) {
        return 'app-icon-24 icon-{0}'.format(result.app.config.icon_id);
      },
      status: 'icon-24 icon-status',
      file: 'icon-24 icon-24-file',
      conversation: 'icon-24 icon-message',
      profile: 'icon-24 icon-user'
    },

    resultIcon: function(result) {
      var icon = this.resultIcons[result.type];
      if (_.isFunction(icon)) {
        icon = icon(result);
      }

      return icon;
    },

    resultTypes: {
      task: t('Task #quick_search'),
      space: t('Workspace #quick_search'),
      app: t('Application #quick_search'),
      item: function(result) {
        return result.app.config.item_name;
      },
      status: t('Status #quick_search'),
      file: t('File #quick_search'),
      conversation: t('Chat #quick_search'),
      profile: t('Profile #quick_search')
    },

    resultType: function(result) {
      var type = this.resultTypes[result.type];
      if (_.isFunction(type)) {
        type = type(result);
      }

      return type;
    },

    resultLocationContext: function(result) {
      var contexts = [];
      if (result.space && result.type !== 'space') {
        contexts.push(result.space.name);
      }
      if (result.org) {
        contexts.push(result.org.name);
      }
      if (contexts.length) {
        var context = contexts.join(' - ');
        return t('in {0} #quick_search').format(context);
      }
    },

    resultAuthorContext: function(result) {
      if (result.type === 'status') {
        return t('by {0} #quick_search').format(result.created_by.name);
      }
    },

    resultInfo: function(result) {
      var info = '<strong>{0}</strong>'.format(_.escape(this.resultType(result)));
      var authorContext = this.resultAuthorContext(result);
      if (authorContext) {
        info += ' ' + _.escape(authorContext);
      }
      var locationContext = this.resultLocationContext(result);
      if (locationContext) {
        info += ' ' + _.escape(locationContext);
      }
      return info;
    },

    resultSecondaryAction: function(result) {
      if (result.type === 'app' && _.contains(result.app.rights, 'add_item')) {
        return {
          url: result.app.url_add,
          icon: 'icon-16 icon-16-green-plus-slim',
          title: t('Create new {0} #updated_navigation').format(result.app.config.item_name),
          hotkey: t('SHIFT + Enter #updated_navigation')
        };
      }
    },

    formatResult: function(result) {
      return {
        id: result.id,
        info: this.resultInfo(result),
        itemIcon: this.resultIcon(result),
        link: result.item ? result.item.link : result.link,
        name: result.title,
        type: result.type,
        secondaryAction: this.resultSecondaryAction(result)
      };
    },

    render : function() {
      return this;
    },

    dispose: function() {
      this.remove();
    },

    expand: function(expandedWidth) {
      var self = this;

      if (self.elm.hasClass('expanded')) {
        self.collapse();
        return;
      }

      function onTransitionEnd() {
        self.elm.addClass('expanded');
        self.elmInput.val('').focus();
        self.elm.bind('outsideclick', self.onSearchOutsideClick);
        self.elm.find('.icon').removeClass('tooltip');

        delete self.forceGlobal;
      }

      // TODO: use Backbone.Mixins.AnimationControl here
      this.elm.one(podioBrowser.cssTransitionEndEvent, _.once(onTransitionEnd));

      this.elm.css('width', expandedWidth);
    },

    collapse: function() {
      this.elm.removeClass('expanded');
      this.elm.css('width', '');
      this.elm.unbind('outsideclick');
      this.elm.find('.icon').addClass('tooltip');

      if (!$('body').hasClass('layout-podio-narrow')) {
        upgradeEle = $('#header-global').find('.user-functions.upgrade-section-tier');
        if (upgradeEle.length > 0) {
          upgradeEle.show();
        }
      }

      if (this.autoCompleter) {
        this.autoCompleter.hide();
      }
    },

    onSearchOutsideClick : function() {
      this.collapse();
    }

  });


});

